import axios from 'axios';

export const ConnectHooksFetcher = async (endpoint: string, token: string) => {
  const requestURL = `${import.meta.env.VITE_CONNECT_HOOKS_ENDPOINT}${endpoint}`;

  const requestHeaders = {
    Authorization: 'Bearer ' + token,
    'Content-Type': 'application/json',
  };

  return await axios.get(requestURL, { headers: requestHeaders });
};
